import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'lien-release.create.max-files',
    options: {
        max_file: 30,
    },
  },
  {
    feature: 'lien-release',
    country: ['US']
  },
] as IAppConfiguration[];
